module.exports = ".profile{\r\n    border:1px solid #ccc;\r\n    padding:50px;\r\n    display:inline-block;\r\n    margin:10px;\r\n    width:100px;\r\n}\r\n\r\n.pad0{\r\n    padding:0px;\r\n}\r\n\r\n@media (min-width: 992px){\r\n    .modal-lg, .modal-xl {\r\n        max-width: 100%;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/unicore-masters/customer-creation/customer-creation.component.css
// module id = ./src/app/unicore-masters/customer-creation/customer-creation.component.css
// module chunks = main